import React from "react";

const imagePath = "/assets/marketing-site/images/team";

const currentTeam = [
	{
		image: "matthew.png",
		name: "Matthew McCloskey",
	},
	{
		image: "desre.png",
		name: "Desre' Milsom",
	},
];

export default function TeamPortraitGroup({ className = "" }) {
	return (
		<div className={`team-portrait-group ${className}`.trim()}>
			{currentTeam.map(({ image, name }) => (
				<img
					key={image}
					src={`${imagePath}/${image}`}
					alt={name}
					loading="lazy"
				/>
			))}
		</div>
	);
}
